const SET_EDIT = "SET_EDIT";
const SET_EDIT_DATA = "SET_EDIT_DATA";
const RESET_DATA = "RESET_DATA";
const RESET_ALL_DATA = "RESET_ALL_DATA";
const SET_PANEL = "SET_PANEL";

export function setEdit(value) {
  return {
    type: SET_EDIT,
    payload: {
      edit: value,
    },
  };
}

export function setPanel(value) {
  return {
    type: SET_PANEL,
    payload: {
      panel: value,
    },
  };
}

export function setEditData(type, id, projectId, isNew) {
  return {
    type: SET_EDIT_DATA,
    payload: {
      edit: true,
      new: isNew,
      data: {
        type: type,
        id: id,
        projectId: projectId,
      },
    },
  };
}

export function resetData() {
  return {
    type: RESET_DATA,
    payload: {
      edit: false,
      data: {
        type: null,
        id: null,
        projectId: null,
      },
    },
  };
}

export function initState() {
  return {
    type: RESET_ALL_DATA,
    payload: {},
  };
}

const INIT_STATE = {
  enabled: false,
  edit: false,
  panel: null,
  new: false,
  data: {
    type: null,
    id: null,
    projectId: null,
  },
};

export default function RiskAnalysisDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_EDIT:
      newState.edit = action.payload.edit;
      break;
    case SET_PANEL:
      newState.panel = action.payload.panel;
      break;
    case SET_EDIT_DATA:
      newState.edit = true;
      newState.new = action.payload.new;
      newState.data.type = action.payload.data.type;
      newState.data.id = action.payload.data.id;
      newState.data.projectId = action.payload.data.projectId;
      break;
    case RESET_DATA:
      newState.edit = false;
      newState.data.type = null;
      newState.data.id = null;
      newState.data.projectId = null;
      break;
    case RESET_ALL_DATA:
      newState = {
        enabled: newState.enabled,
        edit: false,
        panel: null,
        new: false,
        data: {
          type: null,
          id: null,
          projectId: null,
        },
      };
      break;
    default:
      break;
  }
  return newState;
}
